// extracted by mini-css-extract-plugin
var _1 = "alignTop__OCgJc";
var _2 = "block__nkhqo";
var _3 = "bottomBlock__IynPI";
var _4 = "cardsContainer__C5f7x";
var _5 = "contacts__LOgxg";
var _6 = "container__yVc50";
var _7 = "footer__YobGX";
var _8 = "footerButton__FFM3P";
var _9 = "info__oxw9_";
var _a = "infoWrapper__IaQNo";
var _b = "navBlock__TOIDh";
var _c = "row__z6PrZ";
var _d = "social__fhvPb";
var _e = "socialContainer__zsEOj";
var _f = "socialTitle__bUZsB";
var _10 = "text__abLhb";
var _11 = "topBlock__Bt44s";
export { _1 as "alignTop", _2 as "block", _3 as "bottomBlock", _4 as "cardsContainer", _5 as "contacts", _6 as "container", _7 as "footer", _8 as "footerButton", _9 as "info", _a as "infoWrapper", _b as "navBlock", _c as "row", _d as "social", _e as "socialContainer", _f as "socialTitle", _10 as "text", _11 as "topBlock" }
export default { "alignTop": _1, "block": _2, "bottomBlock": _3, "cardsContainer": _4, "contacts": _5, "container": _6, "footer": _7, "footerButton": _8, "info": _9, "infoWrapper": _a, "navBlock": _b, "row": _c, "social": _d, "socialContainer": _e, "socialTitle": _f, "text": _10, "topBlock": _11 }
